import React from 'react';
import MUITextField, { TextFieldProps as MUITextFieldProps } from '@mui/material/TextField';

export type TextFieldProps = Omit<
    MUITextFieldProps,
    'name' | 'label' | 'value' | 'onChange' | 'multiline' | 'maxRows' | 'minRows' | 'disabled'
> & {
    name: string;
    label: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
    multiline?: boolean;
    maxRows?: number;
    minRows?: number;
    disabled?: boolean;
    readOnly?: boolean;
};

const TextField = ({ name, multiline, label, value, onChange, disabled, readOnly, ...rest }: TextFieldProps) => {
    return (
        <MUITextField
            name={name}
            label={label}
            multiline={multiline}
            value={value}
            onChange={onChange}
            disabled={disabled}
            InputProps={{ readOnly }}
            {...rest}
        />
    );
};

export default TextField;
